import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpClient,
} from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class GeoInterceptor implements HttpInterceptor {
  constructor(private http: HttpClient ) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isGeoApi = request.url.startsWith(environment.GEO_API_BASE_URL);
    if ( isGeoApi) {

      let clientId = environment.GEO_API_CLIENT_ID;
      let secret = environment.GEO_API_CLIENT_SECRET;
      return this.http.post(
          environment.GEO_API_Auth_URL,
          `grant_type=client_credentials&client_id=${clientId}&client_secret=${secret}&scope=${environment.GEO_API_SCOPE}`,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }
      ).pipe(
              switchMap((resAuth: any) => {
                  let token = resAuth.access_token;

                  const newRequest = request.clone({
                      setHeaders: {
                          Authorization: `Bearer ${token}`
                      }
                  });

                  return next.handle(newRequest);
              }));


      
    }
    return next.handle(request);
  }
}
